var ProjectsCallSourceTypesEnum;
(function (ProjectsCallSourceTypesEnum) {
    ProjectsCallSourceTypesEnum["BellNotification"] = "BellNotification";
    ProjectsCallSourceTypesEnum["ProjectsLister"] = "ProjectsLister";
    ProjectsCallSourceTypesEnum["NewProjectInProjectsLister"] = "NewProjectInProjectsLister";
    ProjectsCallSourceTypesEnum["ConfirmationLibraryToast"] = "ConfirmationLibraryToast";
    ProjectsCallSourceTypesEnum["NewProjectInLibrary"] = "NewProjectInLibrary";
    ProjectsCallSourceTypesEnum["ProjectAttachmentInMessages"] = "ProjectAttachmentInMessages";
    ProjectsCallSourceTypesEnum["InviteToProjectInMessages"] = "InviteToProjectInMessages";
    ProjectsCallSourceTypesEnum["ConfirmationMessagesToast"] = "ConfirmationMessagesToast";
    ProjectsCallSourceTypesEnum["ViewProjectInMessages"] = "ViewProjectInMessages";
    ProjectsCallSourceTypesEnum["ViewProjectInLearnSection"] = "ViewProjectInLearnSection";
})(ProjectsCallSourceTypesEnum || (ProjectsCallSourceTypesEnum = {}));
var ProjectPageQueryParams;
(function (ProjectPageQueryParams) {
    ProjectPageQueryParams["AssetId"] = "assetId";
    ProjectPageQueryParams["AnnotationId"] = "annotationId";
    ProjectPageQueryParams["ProjectTab"] = "projectTab";
    ProjectPageQueryParams["Source"] = "source";
})(ProjectPageQueryParams || (ProjectPageQueryParams = {}));

export { ProjectPageQueryParams, ProjectsCallSourceTypesEnum };
